let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dSz1k")).then(() => parcelRequire('6uNmH'));